import { render, staticRenderFns } from "./TaskTableComponent.vue?vue&type=template&id=03b09bc6&"
import script from "./TaskTableComponent.vue?vue&type=script&lang=js&"
export * from "./TaskTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports